export const ETAPA_MOTIVO_DA_SEPARACAO = 'motivoDaSeparacao';
export const ETAPA_QUEM_PERMANECE_NA_INSCRICAO = 'donoDaInscricao';
export const ETAPA_ESTADO_CIVIL = 'estadoCivil';
export const ETAPA_DEPENDENTES = 'dependentes';
export const ETAPA_IMOVEIS = 'imoveis';
export const ETAPA_PROGRAMAS_SOCIAIS = 'programasSociais';
export const ETAPA_CONFIRMACAO = 'confirmacao';
